/**
 * AP-28 Nachtrag N-12 — **die Preiseinheit als Zahlenfeld mit Vorschlägen.**
 *
 * Eine ganze Zahl von 1 bis 1.000.000; 1, 100 und 1000 stehen als Vorschläge in
 * der `datalist`, sind aber keine Grenze. Der Wert bleibt als Text im Formular,
 * geprüft wird vor dem Speichern mit `lesePreiseinheit`.
 */

import { useId } from 'react'
import { PRICE_UNIT_MAX, PRICE_UNIT_SUGGESTIONS, istGueltigePreiseinheit } from '@symphenia/shared-types'

interface Props {
  value: string
  onChange: (text: string) => void
  disabled?: boolean
  className?: string
  id?: string
}

export function PriceUnitInput({ value, onChange, disabled, className, id }: Props) {
  const listId = useId()
  return (
    <>
      <input
        id={id}
        type="number"
        inputMode="numeric"
        min={1}
        max={PRICE_UNIT_MAX}
        step={1}
        list={listId}
        disabled={disabled}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={className}
      />
      <datalist id={listId}>
        {PRICE_UNIT_SUGGESTIONS.map((p) => (
          <option key={p} value={p} />
        ))}
      </datalist>
    </>
  )
}

/** Text aus dem Feld → gültige Preiseinheit oder `null`. Leer gilt als ungültig. */
export function lesePreiseinheit(text: string): number | null {
  const roh = text.trim()
  if (!/^\d+$/.test(roh)) return null
  const zahl = Number(roh)
  return istGueltigePreiseinheit(zahl) ? zahl : null
}
